export const SET_PROFILES = "SET_PROFILES";
export const SET_DISTRICTS = "SET_DISTRICTS";
export const SET_REGIONS = "SET_REGIONS";
export const SET_DISTRIC_INFO = "SET_DISTRIC_INFO";
export const SET_REGION_INFO = "SET_REGION_INFO";